
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class WorkOrderItemsGrid extends Serenity.EntityGrid<WorkOrderItemsRow, any> {
        protected getColumnsKey() { return 'Production.WorkOrderItems'; }
        protected getDialogType() { return WorkOrderItemsDialog; }
        protected getIdProperty() { return WorkOrderItemsRow.idProperty; }
        protected getInsertPermission() { return WorkOrderItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return WorkOrderItemsRow.localTextPrefix; }
        protected getService() { return WorkOrderItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}